<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">components</p>
        <h1 class="dg-header">Breadcrumbs</h1>
        <p>Breadcrumbs show the user where they currently are within the website or application structure.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
    
        <div class="row">
          <div class="col mb-4">
            <p class="h3 dg-subheader">Example</p>
            <ComponentExample>
              <template slot="ui-example">
                <nav aria-label="breadcrumb" role="navigation">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li class="breadcrumb-item">
                      <a href="#">Library</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Data</li>
                  </ol>
                </nav>
              </template>
<template slot="code-example">&lt;nav aria-label=&quot;breadcrumb&quot; role=&quot;navigation&quot;&gt;
  &lt;ol class=&quot;breadcrumb&quot;&gt;
    &lt;li class=&quot;breadcrumb-item&quot;&gt;
      &lt;a href=&quot;#&quot;&gt;Home&lt;/a&gt;
    &lt;/li&gt;
    &lt;li class=&quot;breadcrumb-item&quot;&gt;
      &lt;a href=&quot;#&quot;&gt;Library&lt;/a&gt;
    &lt;/li&gt;
    &lt;li class=&quot;breadcrumb-item active&quot; aria-current=&quot;page&quot;&gt;Data&lt;/li&gt;
  &lt;/ol&gt;
&lt;/nav&gt;</template>
              <template slot="link">
                <a href="https://codepen.io/emichigan/pen/yKKjKx" class="edit-link btn btn-primary btn-sm" target="_blank">Edit on Codepen</a>
              </template>
            </ComponentExample>
        </div>
      </div>

        <!-- <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Variants / Modifiers</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi ad doloremque rem quasi voluptatum temporibus voluptates non unde, veritatis molestias velit impedit iste tenetur officiis et quae nisi facilis atque!</p>
          </div>
        </div> -->

        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Accessibility</p>
            <p>Since breadcrumbs provide a navigation, it’s a good idea to add a meaningful label such as <span class="code">aria-label="breadcrumb"</span> to describe the type of navigation provided in the <span class="code">nav</span> element, as well as applying an <span class="code">aria-current="page"</span> to the last item of the set to indicate that it represents the current page.</p>
          </div>
        </div>

      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
import ComponentExample from "../ComponentExample";

export default {
  name: "Breadcrumbs",
  components: {
    ComponentExample
  }
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
.breadcrumb {
  padding: 0;
  margin-bottom: 0;
}
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Breadcrumbs.vue